<template>
  <v-dialog v-model="showContactUs" scrollable persistent max-width="490">
    <v-card>
      <v-card-title>
        <h5 class="pt-5 pb-7">Fale Conosco</h5>
      </v-card-title>
      <v-card-text class="align-center justify-center">
        <v-form ref="contactUsForm" v-model="isFormValid">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                outlined
                hide-details="auto"
                label="Nome"
                required
                :rules="[validateName]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="email"
                outlined
                hide-details="auto"
                label="E-mail"
                required
                :rules="[validateEmail]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-mask="['(##) #####-####', '(##) ####-####']"
                v-model="phone"
                outlined
                hide-details="auto"
                label="Celular"
                required
                :rules="[validatePhone]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="message"
                rows="5"
                row-height="25"
                auto-grow
                outlined
                hide-details="auto"
                label="Mensagem"
                required
                :rules="[validateMessage]"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider class="lg"></v-divider>
      <v-card-actions class="px-6 py-5 d-flex space-between">
        <v-btn rounded large depressed outlined class="gray px-12" @click="hide()">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="info"
          rounded
          large
          depressed
          class="px-12"
          @click="send()"
          :loading="sending"
          :disabled="!isFormValid"
        >Enviar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
    
<script>
import CommonHelper from "@/scripts/helpers/common.helper";
import GeneralService from "@/scripts/services/general.service";
export default {
  props: ["value"],
  data: () => ({
    generalService: new GeneralService(),
    showContactUs: false,
    name: "",
    email: "",
    phone: "",
    message: "",
    isFormValid: false,
    sending: false
  }),
  watch: {
    value() {
      this.showContactUs = this.value;
      if (this.showContactUs) {
        this.clearForm();
      }
    },
    showContactUs() {
      this.$emit("input", this.showContactUs);
    }
  },
  methods: {
    hide() {
      this.showContactUs = false;
      this.$emit("input", this.value);
    },
    clearForm() {
      this.name = "";
      this.email = "";
      this.phone = "";
      this.message = "";
      this.isFormValid = false;
      if (this.$refs.contactUsForm) this.$refs.contactUsForm.reset();
    },
    validateName() {
      if (!this.name) return "Preencha o nome";
      return true;
    },
    validateEmail() {
      this.email = this.email.trim();
      if (!this.email) return "Preencha o e-mail";
      if (!CommonHelper.validateEmail(this.email))
        return "E-mail inválido";
      return true;
    },
    validatePhone() {
      if (!this.phone) return "Preencha o celular";
      return true;
    },
    validateMessage() {
      if (!this.message) return "Preencha a mensagem";
      return true;
    },
    send() {
      this.sending = true;
      let contactUs = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        message: this.message
      };
      this.generalService
        .saveContactUs(contactUs)
        .then(this.showSuccessMessage)
        .finally(() => (this.sending = false));
    },
    showSuccessMessage() {
      CommonHelper.swal(
        "Sucesso",
        "Um e-mail foi enviado para um de nossos representantes. Logo entraremos em contato.",
        "success"
      );
      this.hide();
    }
  }
};
</script>